module.exports = __webpack_public_path__ + "img/quest_icon_0035_runes.01d8b219.png";